import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModuleImage',
  props: {
    configuratorImage: null
  },
  setup(__props: any) {



const loaded = ref(false);

function handleLoad() {
    loaded.value = true;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: __props.configuratorImage,
    alt: "configuration image",
    class: _normalizeClass(["opacity-0 transition-opacity duration-600 ease-in-out w-full aspect-ratio-1/1", { 'opacity-100': loaded.value }]),
    onLoad: handleLoad
  }, null, 42, _hoisted_1))
}
}

})